import { Link, useParams } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { useBoard, useLibraries } from '@/lib/api/queries';
import { useSessionStore } from '@/stores/session';

export function Breadcrumbs() {
  const { ws = '', boardId, libraryId } = useParams();
  const wsId = useSessionStore((s) => s.workspace?.id);
  const board = useBoard(boardId);
  const libs = useLibraries(wsId);
  const lib = libs.data?.find((l) => l.id === (board.data?.library_id ?? libraryId));
  const crumbs: Array<{ id: string; name: string; to: string }> = [];
  if (lib) crumbs.push({ id: lib.id, name: lib.name, to: `/w/${ws}/l/${lib.id}` });
  for (const c of board.data?.breadcrumbs ?? []) crumbs.push({ id: c.id, name: c.name, to: `/w/${ws}/b/${c.id}` });
  if (board.data && !crumbs.some((c) => c.id === board.data.id)) crumbs.push({ id: board.data.id, name: board.data.name, to: `/w/${ws}/b/${board.data.id}` });
  if (crumbs.length === 0) return <span className="truncate text-sm font-medium text-fg-muted">{location.pathname.includes('/search') ? 'Search' : location.pathname.includes('/people') ? 'People' : location.pathname.includes('/settings') ? 'Settings' : ''}</span>;
  return (
    <nav aria-label="Breadcrumb" className="flex min-w-0 items-center gap-1 text-sm">
      {crumbs.map((c, i) => {
        const last = i === crumbs.length - 1;
        return (
          <span key={c.id} className="flex min-w-0 items-center gap-1">
            {i > 0 && <ChevronRight size={14} className="shrink-0 text-fg-subtle" />}
            {last ? (
              <span className="truncate font-semibold" aria-current="page">
                {c.name}
              </span>
            ) : (
              <Link to={c.to} className="truncate text-fg-muted hover:text-fg hover:underline">
                {c.name}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
